import React, { useState, useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import ProductCard from '../components/ProductCard';

export default function Tienda() {
  const [params] = useSearchParams();
  const q = (params.get('q') || '').toLowerCase();
  const [category, setCategory] = useState('all');
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.getProducts(), api.getValueLists()])
      .then(([prods, lists]) => {
        setProducts(prods);
        setCategories(lists.find((l) => l.id === 'categorias')?.values.filter((v) => v.active) || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => products.filter((p) => {
    const matchQ = !q || p.name.toLowerCase().includes(q) || (p.shortDescription || '').toLowerCase().includes(q);
    const matchCat = category === 'all' || p.category === category;
    return matchQ && matchCat;
  }), [products, q, category]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-black text-stone-800 mb-2" data-testid="tienda-title">Tienda</h1>
      <p className="text-stone-500 mb-8">Matrículas, bonos de clases y cursos. Todo online, sin complicaciones.</p>

      <div className="flex flex-wrap gap-2 mb-10" data-testid="category-filters">
        <button onClick={() => setCategory('all')} className={`px-4 py-2 text-sm font-bold rounded-full border transition-colors ${category === 'all' ? 'bg-stone-800 text-white border-stone-800' : 'bg-white text-stone-600 border-stone-300 hover:border-stone-500'}`} data-testid="filter-all">
          Todos
        </button>
        {categories.map((c) => (
          <button key={c.id} onClick={() => setCategory(c.id)} className={`px-4 py-2 text-sm font-bold rounded-full border transition-colors ${category === c.id ? 'bg-stone-800 text-white border-stone-800' : 'bg-white text-stone-600 border-stone-300 hover:border-stone-500'}`} data-testid={`filter-${c.id}`}>
            {c.label}
          </button>
        ))}
      </div>

      {q && <p className="text-sm text-stone-500 mb-6">Resultados para: <strong>“{q}”</strong> ({filtered.length})</p>}

      {loading ? (
        <div className="text-center py-20 text-stone-400">Cargando catálogo…</div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-20 text-stone-400" data-testid="no-results">No se encontraron productos.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="products-grid">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
